import { variables } from "../../variables";

export default {
    actions: {
        async _createPaperwork(context, body){
            return await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/proceeding-types`, body);
        },
        async _updatePaperwork(context, { body, paperworkId }){
            return await context.rootGetters.api.put(`${variables.serverUrl}/api/v1/proceeding-types/${paperworkId}`, body);
        },
        async _deletePaperwork(context, { paperworkId }){
            return await context.rootGetters.api.delete(`${variables.serverUrl}/api/v1/proceeding-types/${paperworkId}`);
        },
        async _getPaperwork(context, { pageSize, pageNumber, proceedingType }){
            return await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/proceeding-types?pageSize=${pageSize}&pageNumber=${pageNumber}&proceedingType=${proceedingType}`);
        }
    }
}